import { render, staticRenderFns } from "./LobbyData.vue?vue&type=template&id=60cd642e&"
import script from "./LobbyData.vue?vue&type=script&lang=js&"
export * from "./LobbyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports